import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const WaterIntakeIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 15 15" {...props}>
      <path
        d="M0.100586 0.207031L1.9235 14.7904H13.0762L13.1648 14.0815L14.8991 0.207031H0.100586ZM1.93616 1.8274H13.0635L12.861 3.44777H2.13871L1.93616 1.8274ZM9.12023 5.06814C9.56745 5.06814 9.93041 5.43111 9.93041 5.87833C9.93041 6.32555 9.56745 6.68851 9.12023 6.68851C8.673 6.68851 8.31004 6.32555 8.31004 5.87833C8.31004 5.43111 8.673 5.06814 9.12023 5.06814ZM5.0693 7.4987C5.51652 7.4987 5.87949 7.86166 5.87949 8.30888C5.87949 8.75611 5.51652 9.11907 5.0693 9.11907C4.62208 9.11907 4.25911 8.75611 4.25911 8.30888C4.25911 7.86166 4.62208 7.4987 5.0693 7.4987ZM7.90495 9.92925C8.57578 9.92925 9.12023 10.4737 9.12023 11.1445C9.12023 11.8154 8.57578 12.3598 7.90495 12.3598C7.23411 12.3598 6.68967 11.8154 6.68967 11.1445C6.68967 10.4737 7.23411 9.92925 7.90495 9.92925Z"
        fill="url(#paint0_linear_4987_53066)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4987_53066"
          x1="12.9457"
          y1="21.7904"
          x2="3.19029"
          y2="1.65428"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77EED8" />
          <stop offset="1" stopColor="#9EABE4" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default WaterIntakeIcon;
